import type { Metadata } from "next";
import { StaticPage } from "@/components/static-page";

export const metadata: Metadata = {
  title: "Miễn trừ đầu tư",
  description:
    "Tuyên bố miễn trừ trách nhiệm đầu tư từ Finzone Network. Nội dung trên trang web không phải là tư vấn đầu tư cá nhân.",
  alternates: { canonical: "/mien-tru-dau-tu" },
};

export default function Page() {
  return (
    <StaticPage
      title="Miễn trừ đầu tư"
      eyebrow="Tuyên bố"
      description="Đọc kỹ trước khi sử dụng nội dung của Finzone cho quyết định tài chính cá nhân."
    >
      <h2>Không phải tư vấn cá nhân hóa</h2>
      <p>
        Mọi nội dung trên Finzone Network — bao gồm tin tức, phân tích, biểu đồ, dự báo, ý kiến —
        là <strong>thông tin tham khảo chung</strong>, không phải lời khuyên đầu tư cá nhân hóa.
        Chúng tôi không biết hoàn cảnh tài chính, mức chấp nhận rủi ro, mục tiêu, thời gian
        đầu tư và nghĩa vụ thuế của từng độc giả. Quyết định mua, bán, nắm giữ bất kỳ tài sản nào
        thuộc về bạn.
      </p>

      <h2>Rủi ro đầu tư</h2>
      <ul>
        <li>
          Mọi khoản đầu tư đều có rủi ro mất một phần hoặc toàn bộ vốn. Lợi nhuận quá khứ
          không bảo đảm lợi nhuận tương lai.
        </li>
        <li>
          Crypto, forex, hàng hóa và cổ phiếu có biến động mạnh. Đòn bẩy có thể khuếch đại
          cả lợi nhuận lẫn lỗ.
        </li>
        <li>
          Vàng SJC trong nước có spread mua-bán và premium so với thế giới có thể thay đổi
          do can thiệp chính sách.
        </li>
      </ul>

      <h2>Khuyến cáo</h2>
      <p>
        Trước khi xuống tiền, bạn nên: (1) tự đọc thêm nguồn gốc dữ liệu chúng tôi trích dẫn,
        (2) đối chiếu với cố vấn tài chính có chứng chỉ hành nghề tại Việt Nam, (3) chỉ đầu tư
        khoản tiền bạn sẵn sàng mất.
      </p>

      <h2>Trách nhiệm</h2>
      <p>
        Finzone Network và tác giả không chịu trách nhiệm về thiệt hại trực tiếp hoặc gián tiếp
        phát sinh từ việc bạn dùng thông tin trên trang. Khi sử dụng trang, bạn chấp nhận
        điều khoản này.
      </p>
    </StaticPage>
  );
}
